const link_length = 15;

module.exports = {
   link_length
}